jQuery(document).ready(function(){
  var timer = setInterval(function(){
    if(jQuery('iframe#timelyWidget').length){
      jQuery('body').addClass('s-express');
    } else {
      jQuery('body').removeClass('s-express');
    }
  }, 50);

  if(jQuery('.square-badges').length == 0){
    var sb = 0; var timersb = setInterval(function(){
      if(jQuery('.product-form span.bold_option_title').length) {
        var btitle = jQuery('.bold_option_title');
        for(var i = 0; i < btitle.length; i++){
          var b = btitle.eq(i).html();
          b = b.replace('*', '<span class="red">*</span>');
        }
        clearInterval(timersb);
      }
      if(sb > 200){ clearInterval(timersb); }
      sb++;
    }, 50);
  }

});
